import { Device } from '@capacitor/device'
import { name } from 'dayjs/locale/id'
import { CapacitorHttp } from "@capacitor/core";
import httpRequest from '@/services/httpRequest.js'

export default ({
  namespaced: true,
  state: {
    openSwitchAccountModal: false,
    menus: [],
    sosButton: false,
    sosResponder: false,
    semesters: [],
    currentSemester: null,
    classrooms: [],
    subjects: [],
    teacherSubjects: [],
    isLoading: false,
    prayerTimes: {},
    location: {},
    allMenu: [
      {
        id: 1,
        nameKey: 'menu.attendance',
        icon: 'calendar',
        subMenus: [
          {
            id: 1,
            nameKey: 'menu.attendanceDaily',
            slug: 'attendance-daily',
            icon: 'calendar',
            destination: '/daily-attendance'
          },
          {
            id: 2,
            nameKey: 'menu.attendanceSubject',
            slug: 'attendance-subject',
            icon: 'calendarBook',
            destination: '/subject-attendance'
          },
        ]
      },
      {
        id: 2,
        nameKey: 'menu.finance',
        icon: 'moneyBag',
        subMenus: [
          {
            id: 1,
            nameKey: 'menu.financePaymentSummary',
            slug: 'finance-payment-summary',
            icon: 'billList',
            destination: '/summary-finance'
          },
          {
            id: 2,
            nameKey: 'menu.financePayment',
            slug: 'finance-payment',
            icon: 'moneyBag',
            destination: '/payment-finance'
          },
          {
            id: 3,
            nameKey: 'menu.financeSavings',
            slug: 'finance-savings',
            icon: 'wallet',
            destination: '/saving-finance'
          },
        ]
      },
      {
        id: 3,
        nameKey: 'menu.recruitment',
        slug: 'recruitment',
        icon: 'building',
        destination: '/recruitment'
      },
      {
        id: 4,
        nameKey: 'menu.journal',
        slug: 'journal',
        icon: 'book',
        destination: '/journal'
      },
      {
        id: 5,
        nameKey: 'menu.academic',
        icon: 'graduationHat',
        subMenus: [
          {
            id: 1,
            nameKey: 'menu.academicCalendar',
            slug: 'academic-calendar',
            icon: 'calendarSixDot',
            destination: '/academic-calendar'
          },
          {
            id: 2,
            nameKey: 'menu.academicSubjectSchedule',
            slug: 'academic-subject-schedule',
            icon: 'calendarBook',
            destination: '/academic-subject-schedule'
          },
          {
            id: 3,
            nameKey: 'menu.academicStudyroom',
            slug: 'academic-studyroom',
            icon: 'classLesson',
            destination: '/academic-studyroom'
          },
          {
            id: 4,
            nameKey: 'menu.academicExam',
            slug: 'academic-exam',
            icon: 'checkAndQuestion',
            destination: '/academic-exam-list'
          },
          {
            id: 5,
            nameKey: 'menu.academicEvaluation',
            slug: 'academic-evaluation',
            icon: 'clipboardCheck',
            destination: '/academic-evaluation'
          },
          {
            id: 6,
            nameKey: 'menu.academicErapor',
            slug: 'erapor',
            icon: 'eRapor',
            destination: '/erapor'
          },
          {
            id: 7,
            nameKey: "menu.academicJournal",
            // slug: "academic-journal",
            slug: "journal-teacher",
            icon: "teacherJournal",
            destination: "/teacher-journal",
          },
        ]
      },
      {
        id: 7,
        nameKey: 'menu.guestbook',
        slug: 'guestbook',
        icon: 'guestBook',
        destination: '/guest-book'
      },
      {
        id: 8,
        nameKey: 'menu.adminRecruitment',
        slug: 'admin-recruitment',
        icon: 'building',
        destination: '/recruitment-admin'
      },
      {
        id: 9,
        nameKey: 'menu.religion',
        icon: 'religions',
        subMenus: [
          {
            id: 1,
            nameKey: 'menu.religionTilawah',
            slug: 'life-tilawah',
            icon: 'tilawah',
            destination: '/religions-tilawah'
          },
          {
            id: 2,
            nameKey: 'menu.religionTahfidz',
            slug: 'life-tahfidz',
            icon: 'tahfidz',
            destination: '/religions-tahfidz'
          },
          {
            id: 3,
            nameKey: 'menu.religionErapor',
            slug: 'life-erapor',
            icon: 'eRapor',
            destination: '/religions-erapor'
          },
        ]
      },
      {
        id: 10,
        nameKey: 'menu.report',
        icon: 'message',
        subMenus: [
          {
            id: 1,
            nameKey: 'menu.reportSos',
            slug: 'report-sos',
            icon: 'sosCalling',
            destination: '/sos-history'
          },
          {
            id: 2,
            nameKey: 'menu.reportLaporin',
            slug: 'report-laporin',
            icon: 'reportingHistory',
            destination: '/laporin'
          },
        ]
      },
      {
        id: 11,
        nameKey: 'menu.studentBill',
        slug: 'finance-payment-student-bill',
        icon: 'moneyBag',
        destination: '/student-bill'
      },
      {
        id: 12,
        nameKey: 'menu.teacherAttendance',
        icon: 'calendar',
        subMenus: [
          {
            id: 1,
            nameKey: 'menu.teacherAttendanceDaily',
            slug: "attendance-teacher-daily",
            icon: "calendar",
            destination: "/teacher-attendance-daily",
          },
          {
            id: 2,
            nameKey: 'menu.teacherAttendanceMonitoring',
            slug: "attendance-teacher-monitoring",
            icon: "teacherMonitoring",
            destination: "/teacher-attendance-monitor",
          },
        ]
      },
    ],
    schedules: [

    ],
    messages: [],
    unreadMessages: 0,
    page: 1,
    rows: 20
  },
  mutations: {
    SET_MENU(state, data) {
      let initialMenu = state.allMenu
      let userMenu = data
      const additionalMenu = []
      additionalMenu.forEach((item) => {
        userMenu.push(item)
      })
      //console.log(userMenu)
      let menus = []

      let allowedSlugs = userMenu.map((item) => item.name);

      initialMenu.forEach((a) => {
        let subMenu = []
        if (a.subMenus) {
          a.subMenus.forEach((b) => {
            if (allowedSlugs.includes(b.slug)) {
              subMenu.push(b)
            }
          })
        }

        if (a.slug && allowedSlugs.includes(a.slug)) {
          menus.push(a)
        } else {
          if (subMenu.length === 1) {
            menus.push(subMenu[0])
          } else if (subMenu.length !== 0) {
            menus.push({
              ...a,
              subMenus: subMenu
            })
          }
        }
      })

      state.menus = menus

      //console.log(menus)
    },
    SET_SOS_BUTTON(state, data) {
      const isSosFound = data.some(item => {
        return item.name.toLowerCase().includes('sos');
      });
      state.sosButton = isSosFound;
    },
    SET_SOS_RESPONDER(state, data) {
      const isResponderFound = data.some(item => {
        return item.name.toLowerCase().includes('sos-responder');
      });
      state.sosResponder = isResponderFound;
    },
    SET_MESSAGES_FIRST(state, data) {
      state.messages = data.results
      state.isLoading = false
    },
    SET_MESSAGES(state, data) {
      data.results.forEach((message) => {
        state.messages.push(message)
      })
      state.isLoading = false
    },
    SET_UNREAD_MESSAGES(state, data) {
      state.unreadMessages = data.unread_count
    },
    SET_PRAYER_TIMES(state, data) {
      state.prayerTimes = data
    },
  },
  actions: {
    async getMenu({ commit, rootState }) {
      //console.log(`URL di get menu = ${rootState.baseURL}`)
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/menu`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)
      if (res.status === 200) {
        commit('SET_MENU', res.data)
        commit('SET_SOS_BUTTON', res.data)
        commit('SET_SOS_RESPONDER', res.data)
      }
    },
    async getSosResponder({ commit, rootState }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/menu`,
          method: 'GET'
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        commit('SET_SOS_RESPONDER', res.data)
      }
    },
    async getSemesters({ state, rootState }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/semester`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)
      if (res.status === 200) {
        state.semesters = res.data.results;
      }
    },
    async getCurrentSemester({ state, rootState }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/semester/current`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)
      if (res.status === 200) {
        state.currentSemester = res.data;
      }
    },
    async getSubjects({ state, rootState }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/subject`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)
      if (res.status === 200) {
        state.subjects = res.data.results;
      }
    },
    async getTeacherSubjects({ state, rootState }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/subjectschedule/teacher_subjects`,
          method: 'POST'
        },
        authorized: true
      }

      const res = await httpRequest(payload)
      if (res.status === 200) {
        state.teacherSubjects = res.data;
      }
    },
    async getTeacherClassrooms({ state, rootState }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/subjectschedule/teacher_classrooms`,
          method: 'POST'
        },
        authorized: true
      }

      const res = await httpRequest(payload)
      if (res.status === 200) {
        return res.data
      }
      return []
    },

    async getMessages({ rootState, commit, state }, status) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/inbox?page=${state.page}&rows=${state.rows}`,
          method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        if (status === 'first') {
          commit('SET_MESSAGES_FIRST', res.data)
        } else {
          commit('SET_MESSAGES', res.data)
        }
      } else {
        state.isLoading = false
      }
    },

    async getUnreadMessages({ rootState, commit, state }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/inbox/unread_count`,
          method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        commit('SET_UNREAD_MESSAGES', res.data)
      } else {
        state.isLoading = false
      }
    },

    async unreadAllMessage({ rootState, dispatch }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/inbox/mark_all_as_read`,
          method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        dispatch('getUnreadMessages')
        return true
      } else {
        return false
      }
    },

    async getStudents({ state, rootState }, { params }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/student`,
          method: 'GET',
          params: params,
        },
        authorized: true
      }

      const res = await httpRequest(payload)
      if (res.status === 200) {
        return res.data.results
      }
      return []
    },

    async getPrayerTimes({ state, commit }, param) {
      const url = 'https://api.aladhan.com/v1/timings'
      const payload = {
        url: `${url}/${param.date}?latitude=${param.latitude}&longitude=${param.longitude}&method=20&language=id`,
        method: 'GET',
      }

      const res = await CapacitorHttp.request(payload)
      if (res.status === 200 && res.data.data.timings) {
        commit('SET_PRAYER_TIMES', res.data.data.timings)
        state.location = {
          latitude: res.data.data.meta.latitude,
          longitude: res.data.data.meta.longitude,
        }
        return true
      }
      return false
    },
  },
  getters: {
    keyValueSemesters: (state) => {
      let semesters = [{
        key: '',
        label: 'Semua Semester',
      }];
      state.semesters.forEach((semester) => {
        const oddeven = semester.semester % 2 === 0 ? 'Genap' : 'Ganjil'
        semesters.push({
          key: semester.id,
          label: `TA ${semester.year} ${oddeven}`,
        })
      })
      return semesters;
    },

    keyValueClassrooms: (state) => {
      let classrooms = [{
        key: '',
        label: 'Semua Kelas',
      }];

      state.classrooms.forEach((classroom) => {
        classrooms.push({
          key: classroom.id,
          label: classroom.name
        })
      })
      return classrooms
    },

    keyValueSubjects: (state) => {
      let subjects = [{
        key: '',
        label: 'Semua Mata Pelajaran',
      }];

      state.subjects.forEach((subject) => {
        subjects.push({
          key: subject.code,
          label: subject.name
        })
      })
      return subjects
    }
  }
})